import { CustomerType } from "@origin-digital/platform-enums";
import { BasicJSONSchema, IMcAppType, NavFlow, Tab } from "../mcApp.types";

// originAccountId is the Origin account id (User DB), passed as a query param.
// It is intentionally NOT the Kraken accountNumber CommonParameter.
const originAccountId: BasicJSONSchema = {
  description: "Origin account id (User DB)",
  type: "string",
};

export const batterySettings: IMcAppType = {
  name: "batterySettings",
  path: "/my/service/battery/settings",
  parameters: {
    required: ["originAccountId"],
    properties: { originAccountId },
  },
  description: "Battery settings page",
  navFlow: NavFlow.FOCUS,
  title: "Battery settings",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "batterySettings",
    customerType: CustomerType.kraken,
  },
};
